import { render } from "./DocumentDetailView.vue?vue&type=template&id=065bb10b&scoped=true"
import script from "./DocumentDetailView.vue?vue&type=script&lang=js"
export * from "./DocumentDetailView.vue?vue&type=script&lang=js"

import "./DocumentDetailView.vue?vue&type=style&index=0&id=065bb10b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065bb10b"]])

export default __exports__